import * as React from 'react';
import { connect } from "react-redux";
import AppMenus from '../../config/appMenus';
import headerReduxProps from "../Header/HeaderReduxProps";
import NavigationItem from './NavigationItem/NavigationItem';
import './Sidebar.css';
var Sidebar = function (props) {
    // AppMenus.prepareMenuItems();
    var menuItems = AppMenus.menuItems;
    return (React.createElement("div", { className: "sidebar " + (props.sidebarVisible ? "show" : "") },
        React.createElement("nav", { className: "sidebar-nav" },
            React.createElement("ul", { className: "nav" }, menuItems.map(function (item) { return (React.createElement(NavigationItem
            // @ts-ignore
            , { 
                // @ts-ignore
                id: item.id, key: item.id, exact: item.exact, link: item.link, icon: item.icon },
                "\u00A0",
                item.name)); })))));
};
export default connect(headerReduxProps.mapStateToProps, null)(Sidebar);



//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.tsx
// module id = 235
// module chunks = 0